<div class="raptor-banner-header" *ngFor="let banner of data">
  <div class="grid">
    <div class="cell cell-large-col-span-12 text-center padding-vertical-xxsmall padding-horizontal-xsmall flex flex-justify-center flex-items-center">
      <div class="margin-right-small" *ngIf="banner.icon && banner.icon.name">
        <open-svg-icon [name]="banner.icon.name" [class]="banner.icon.size"></open-svg-icon>
      </div>
      <div [innerHTML]="banner.content"></div>
    </div>
  </div>
</div>
